import {useTypedSelector} from "./selectors.utils";

export const useWorkPackagesSelector = () => useTypedSelector(state => state.workPackages.workPackageList);
export const useWorkStreamsSelector = () => useTypedSelector(state => state.workPackages.workStreamList);
export const useProjectHasWorkPackagesSelector = () => useTypedSelector(state => state.workPackages.workPackageList.length > 0);
export const useWorkPackageMapSelector = () => useTypedSelector(state => state.workPackages.workPackageMap);
export const useActiveWorkPackageSelector = () => useTypedSelector(state => state.workPackages.activeWorkPackage);